import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function FinalCTA() {
  return <section id="contact" className="py-24 relative overflow-hidden" data-id="element-33">
      <div className="absolute inset-0 bg-brand-gradient animate-gradient-pan bg-size-200" data-id="element-34"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-35">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-bold text-white mb-6" data-id="element-36">
          Ready to Build Your Team?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-37">
          Tell us what you're hiring for, and we'll help you find exceptional
          professionals across Latin America who are ready to make an impact.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-38">
          <a href="https://calendly.com/partners-talvoritalents/30min?month=2026-06" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-navy bg-white rounded-full hover:scale-105 transition-transform shadow-soft-lg mb-12" data-id="element-39">
            Book a Free Consultation
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="flex flex-col sm:flex-row justify-center items-center gap-6 text-white/90 font-medium text-sm" data-id="element-40">
          <div className="flex items-center gap-2" data-id="element-41">
            <CheckCircle2 className="w-5 h-5" data-id="element-42" />
            <span data-id="element-43">Carefully Vetted Talent</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-44">
            <CheckCircle2 className="w-5 h-5" data-id="element-45" />
            <span data-id="element-46">5–10 Day Shortlist</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-47">
            <CheckCircle2 className="w-5 h-5" data-id="element-48" />
            <span data-id="element-49">Replacement Guarantee</span>
          </div>
        </motion.div>
      </div>
    </section>;
}